module.exports = __webpack_public_path__ + "img/kommune-2019.1519bc34.svg";